module.exports = __webpack_public_path__ + "img/Fernsprechen_über_Draht.34b48d87.svg";